/** LoadStatus enumerates the different states the app needs to handle while loading configuration. */
export enum LoadStatus {
  Loading,
  Success,
  Error,
}
